import Auth from './auth'

import './middleware'

// Active schemes
import scheme_003d9a64 from './schemes/local.js'

export default function (ctx, inject) {
  // Options
  const options = {"resetOnError":false,"scopeKey":"scope","rewriteRedirects":false,"fullPathRedirect":true,"watchLoggedIn":true,"redirect":{"login":"/login","logout":"/logout","home":"/","callback":"/login"},"vuex":{"namespace":"auth"},"cookie":{"prefix":"ibjjf.auth.","options":{"path":"/","domain":".ibjjfdb.com","secure":true}},"localStorage":false,"token":{"prefix":"_token."},"refresh_token":{"prefix":"_refresh_token."},"defaultStrategy":"local"}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new scheme_003d9a64($auth, {"endpoints":{"login":{"url":"/users/login","method":"post","propertyName":"data.token","baseURL":"https://core.ibjjf.com"},"logout":false,"user":{"url":"/users/me","method":"get","propertyName":"data","baseURL":"https://core.ibjjf.com"}},"_name":"local"}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      console.error('[ERROR] [AUTH]', error)
    }
  })
}
